import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import { MotionConfig } from 'framer-motion';

// Recover once when an open tab requests a chunk removed by a new deployment.
window.addEventListener('vite:preloadError', event => {
  try {
    const key = 'pbs_chunk_reload_at';
    const last = Number(sessionStorage.getItem(key) || 0);
    if (Date.now() - last < 60000) return;
    sessionStorage.setItem(key, String(Date.now()));
    event.preventDefault();
    window.location.reload();
  } catch {
    // Keep the normal error boundary if browser storage is unavailable.
  }
});

// Fix 100vh on mobile
function setVhProperty() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', setVhProperty);
window.addEventListener('orientationchange', setVhProperty);
setVhProperty();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MotionConfig reducedMotion="user">
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </MotionConfig>
  </StrictMode>
);

// Buffered observers let performance measurement load after the page itself.
const loadVitals = () => { void import('./lib/webVitals').then(module => module.startWebVitals()).catch(() => {}); };
if (document.readyState === 'complete') loadVitals();
else window.addEventListener('load', loadVitals, { once: true });
